import * as DesignerFunctions from '../utilities/DesignerFunctions';
import * as CoreFns from '../utilities/CoreFns';

function App(props) {

  var currentList = props.currentList;
  var itemEdited = props.itemEdited;
  var organicChanges = props.organicChanges;
  var preText = props.preText;

  var pathDown = itemEdited.path;

  var editorBarTitle;
  var thisFE = CoreFns.goDownPath(currentList, pathDown);

  if (thisFE){
    editorBarTitle = DesignerFunctions.fullTitle(itemEdited, currentList, pathDown, thisFE);
  }else{
    editorBarTitle = 'No Element Selected';
  }


  function titleEditor(path, loc){
      function amendTitle(e){
        var existingItem = CoreFns.goDownPath(currentList, path);
        var tit = '';
        if (existingItem[loc]){
          tit = existingItem[loc];
        }
        var p = window.prompt('New Title?', tit);
        if (p){
          var changes = [{t:'w',w:path.concat([loc]),n:p}];
          organicChanges(changes);
        }
      }
     return <span style={{cursor:'pointer'}}><b>{preText}<u onClick={amendTitle}>{editorBarTitle}</u></b></span>
//
  }

  var editorBarTitleOut;
  if (editorBarTitle){
    if (thisFE){
      if (itemEdited.t === 'page'){
        editorBarTitleOut = titleEditor(itemEdited.path, 'n');
      }else if (itemEdited.t === 'screen' || itemEdited.t === 'item' || itemEdited.t === 'alert' || itemEdited.t === 'asset'){
        editorBarTitleOut = titleEditor(itemEdited.path, '_na');
      }else{
        editorBarTitleOut = <b>{preText}{editorBarTitle}</b>
      }
  //      
    }else{
      editorBarTitleOut = titleEditor(pathDown, 'n');
    }
  }else{
    editorBarTitleOut = '';
  }

  return <center><p className='lead mb-0 explanation'>{editorBarTitleOut}</p></center>



}

export default App;
